import { useEffect } from "react";

import { useLocation } from "@remix-run/react";

import { analytics } from "./analytics.client";

export function useTrackPageView() {
    const location = useLocation();
    useEffect(() => {
        analytics.trackPageView();
    }, [location]);
}

export function useTrackLinks(
    selector: string,
    eventName: string,
    properties: Record<string, string | number | boolean | undefined | null>,
) {
    useEffect(() => {
        analytics.trackLinks(selector, eventName, properties);
    }, [selector, eventName, properties]);
}
